import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getMBMAVOBBoxs } from "services/ConfigServices";
import { avobboxtext } from "variables/MBM/avobbox";
import { typeData } from "variables/MBM/lists/avobbox";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddAVOBBox from "./AddAVOBBox";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useIotDevicesTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMAVOBBoxs(chartIdGroup, "avobenergybox");
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [avobboxsdata, setAvobboxsData] = useState([]);
  const [avobboxs, setAvobboxs] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        // let resultstmp = response.data.avobboxs || [];
        // resultstmp.forEach((box)=>{
        //   console.log(box);
        //   if(box.lasthealth)
        //   {
        //     console.log(box.lasthealth);
        //     let lorawanhealth = 0;
        //     let sessions = box.sessions;
        //     let sessionlora = sessions.find((session)=>session.type===5);
        //     let lasthealth = box.lasthealth;
        //     if(sessionlora)
        //     {
        //       if(!lasthealth?.['chirpstack-rest-api']?.health)
        //         lorawanhealth = 1;
        //       if(!lasthealth?.system?.services?.['chirpstack-app'])
        //         lorawanhealth = 1;
        //       if(!lasthealth?.system?.services?.['chirpstack-bridge'])
        //         lorawanhealth = 1;
        //       if(!lasthealth?.system?.services?.['postgres'])
        //         lorawanhealth = 1;
        //       console.log(lorawanhealth);
        //       if(lorawanhealth!==1)
        //       {
        //         let gateways = lasthealth?.['chirpstack-rest-api']?.gateways || [];
        //         let connected = 0;
        //         gateways.forEach((gateway)=>{
        //           let lastseen = gateway.lastSeenAt;
        //           lastseen = lastseen.replace("\\/","/");
        //           console.log(lastseen);

        //         });
        //       }
        //     }
        //   }


        // });
        setResults(response.data);
        setAvobboxsData(response.data.avobboxs);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `avobboxs`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.uniqueid && item.uniqueid.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.version && item.version.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.description && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastconnection && moment(item.lastconnection).isValid() && moment(item.lastconnection).format("DD/MM/YYYY hh:mm:ss").includes(filterText)) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = avobboxs.map((item) => {
      let avobboxtoexport = {};
      avobboxtoexport[avobboxtext.id] = item.id;
      avobboxtoexport[avobboxtext.name] = item.name;
      avobboxtoexport[avobboxtext.uniqueid] = item.uniqueid;
      avobboxtoexport[avobboxtext.version] = item.version;
      avobboxtoexport[avobboxtext.description] = item.description;
      avobboxtoexport[avobboxtext.lorawanstate] = item.lasthealth?.healthanalyse?.lorastate || 0;
      avobboxtoexport[avobboxtext.sessionstate] = item.lasthealth?.healthanalyse?.sessionstate || 0;
      avobboxtoexport[avobboxtext.diskusage] = (item.lasthealth?.healthanalyse?.diskusage || 0) + "%";
      avobboxtoexport[avobboxtext.group] = groupInfoListById["" + item.groupid];
      avobboxtoexport[avobboxtext.lastconnection] = (item.lastconnection && moment(item.lastconnection).isValid()) ? moment(item.lastconnection).format("DD/MM/YYYY hh:mm:ss") : "";
      return avobboxtoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              {/* <AddAVOBBox refetch={refreshTable} onClick={handleClear} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!avobboxs || avobboxs.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, avobboxsdata, avobboxs]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setAvobboxs
  };
}
